export type ColorClassSuffix =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "electricity"
  | "gas"
  | "heat"
  | "price"
  | "default"
  | "production"
  | "emobility"
  | "centralHeating"
  | "domesticHotWater"
  | "totalHeat";

export const ColorClassSuffix = {
  Primary: "primary" as ColorClassSuffix,
  Secondary: "secondary" as ColorClassSuffix,
  Success: "success" as ColorClassSuffix,
  Danger: "danger" as ColorClassSuffix,
  Warning: "warning" as ColorClassSuffix,
  Info: "info" as ColorClassSuffix,
  Electricity: "electricity" as ColorClassSuffix,
  Gas: "gas" as ColorClassSuffix,
  Heat: "heat" as ColorClassSuffix,
  Price: "price" as ColorClassSuffix,
  Default: "default" as ColorClassSuffix,
  Production: "production" as ColorClassSuffix,
  Emobility: "emobility" as ColorClassSuffix,
  CentralHeating: "centralHeating" as ColorClassSuffix,
  DomesticHotWater: "domesticHotWater" as ColorClassSuffix,
  TotalHeat: "totalHeat" as ColorClassSuffix,
};
